<template>
  <div class="item-wrap">
    <div class="title-wrap">
      <span>第{{ index + 1 }}段</span>
      <AudioPlay ref="audioPlay" :audios="topic.audios" />
    </div>
    <div class="tigan-duan">
      <div class="tiGan" v-html="topic.tiGan.html" />
      <div class="img-wrap" v-if="imgHtml" v-html="imgHtml" />
    </div>
  </div>
</template>
<script>
import AudioPlay from './AudioPlay.vue'
export default {
  components: {
    AudioPlay
  },
  props: {
    topic: Object,
    index: Number
  },
  computed: {
    imgHtml() {
      const { images } = this.topic
      if (images && images.length) {
        return images[0].html
      }
      return ''
    }
  }
}
</script>
<style lang="less" scoped>
.item-wrap {
  border: 1px solid #DFE2E6;
  border-radius: 6px;
  padding: 10px 15px;
  margin-bottom: 12px;
  margin-left: -20px;
  line-height: 22px;
  &:last-child {
    margin-bottom: 0;
  }
}
.title-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  span {
    margin-right: 4px;
  }
}
.tigan-duan {
  display: flex;
  :deep(img) {
    max-width: none !important;
    max-height: 92px;
    height: auto !important;
    width: auto !important;
    margin-left: 12px;
  }
}
</style>